import CustomSelect from "./CustomSelect";
import { useTranslation } from "react-i18next";

const PreferenceLanguageSelector = ({ value, onChange, placeholder, className, size = "md" }) => {
  const { t } = useTranslation();
  const languageOptions = [
    { value: "en", label: t("language.english") },
    { value: "ko", label: t("language.korean") },
    { value: "ja", label: t("language.japanese") }
  ];

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      onChange(selectedOption.value);
    } else {
      onChange("");
    }
  };

  const selectedValue = languageOptions.find(option => option.value === value) || null;

  return (
    <CustomSelect
      options={languageOptions}
      value={selectedValue}
      onChange={handleChange}
      placeholder={placeholder || "Select language"}
      className={className}
      size={size}
      isSearchable={false}
      clearable={false}
    />
  );
};

export default PreferenceLanguageSelector; 